<template lang="html">
  <div class="inner-modal">
		<div class="head-modal row">
			<div class="title column">
				<div class="head-modal-title">
					Editer un client
				</div>
				<div class="head-modal-emphase">
					Editer les informations du client
				</div>
			</div>
			<div class="form-elem-container small row">
				<div class="ctn-input ctn-label">
					<label>Type Contact</label>
					<custom-select :items="prospectTypes" :selected="user.type" @change="user.type=$event"/>
				</div>
			</div>
		</div>
		<div class="body-modal">
			<form class="form-ui column default-form-ui">
				<div class="ctn-duo-input row">
					<div class="left inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('name')}">
							<label for="name">Nom</label>
							<input v-validate="'required|alpha_dash_spaces'" type="text" name="name" v-model="user.lastname">
						</div>
						<div v-if="errors.has('name')" class="error-message">{{ errors.first('name') }}</div>
					</div>
					<div class="right inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('firstname')}">
							<label for="firstname">Prénom</label>
							<input v-validate="'required|alpha_dash_spaces'" type="text" name="firstname" v-model="user.firstname">
						</div>
						<div v-if="errors.has('firstname')" class="error-message">{{ errors.first('firstname') }}</div>
					</div>
				</div>
				<div class="ctn-duo-input row">
					<div class="left inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('phone')}">
							<label for="phone">Téléphone</label>
							<input v-validate="'required'" type="phone" name="phone" v-model="user.phone">
						</div>
						<div v-if="errors.has('phone')" class="error-message">{{ errors.first('phone') }}</div>
					</div>
					<div class="right inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('date de naissance')}">
							<label for="date de naissance">Date de naissance</label>
							<input v-validate="'required'" type="date" name="date de naissance" v-model="user.birthdate">
						</div>
						<div v-if="errors.has('date de naissance')" class="error-message">{{ errors.first('date de naissance') }}</div>
					</div>
				</div>
				<div class="form-elem-container">
					<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('mail')}">
						<label for="mail">Adresse mail</label>
						<input v-validate="'required|email'" type="mail" name="mail" v-model="user.email">
					</div>
					<div v-if="errors.has('mail')" class="error-message">{{ errors.first('mail') }}</div>
				</div>

				<div class="ctn-duo-input row">
					<div class="left inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('address')}">
							<label for="address">Adresse</label>
							<input v-validate="'required'" type="text" name="address" v-model="user.address.line">
						</div>
						<div v-if="errors.has('address')" class="error-message">{{ errors.first('address') }}</div>
					</div>
					<div class="right inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('zip')}">
							<label for="zip">Code postal</label>
							<input v-validate="'required'" type="text" name="zip" v-model="user.address.zip">
						</div>
						<div v-if="errors.has('zip')" class="error-message">{{ errors.first('zip') }}</div>
					</div>
				</div>

				<div class="ctn-duo-input row">
					<div class="left inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('city')}">
							<label for="city">Ville</label>
							<input v-validate="'required'" type="text" name="city" v-model="user.address.city">
						</div>
						<div v-if="errors.has('city')" class="error-message">{{ errors.first('city') }}</div>
					</div>
					<div class="right inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('country')}">
							<label for="country">Pays</label>
							<input v-validate="'required'" type="text" name="country" v-model="user.address.country">
						</div>
						<div v-if="errors.has('country')" class="error-message">{{ errors.first('country') }}</div>
					</div>
				</div>

				<div class="form-elem-container ctn-select ctn-label">
					<label for="select">Origine du contact</label>
					<custom-select :items="origins" :selected="user.origin" :solo="true" @change="user.origin = $event"/>
				</div>
				<div class="form-elem-container ctn-select ctn-label">
					<label for="">Centres d'intérêts</label>
					<custom-multiselect :values="user.centerOfInterests" :list="interests" :object="true" :getter="'wordpress_tag_name'" :solo="true" @change="setNewCenterOfInterests($event)"/>
				</div>
				<div v-if="errors.has('origin')" class="error-message">{{ errors.first('origin') }}</div>
				<div class="ctn-cta right row">
					<div class="btn btn-gold" @click="close">Annuler</div>
					<div class="btn btn-red" @click="addContact">Envoyer</div>
				</div>
			</form>
		</div>
  </div>
</template>

<script>
import CustomMultiselect from '@/common/components/Form/CustomMultiselect'
import CustomSelect from '@/common/components/Form/CustomSelect'
import { mapGetters } from 'vuex'
import { Validator } from 'vee-validate'

Validator.extend('alpha_dash_spaces', {
	getMessage: field => 'Le champ ' + field + ' ne peut contenir que des caractères des tirets et des espaces',
	validate: value => {
		for (let i = 0; i < value.length; i++) {
			if ('abcdefghijklmnopqrstuvwxyzçéèêîïë -'.indexOf(value[i].toLowerCase()) === -1) { return false }
		}
		return true
	}
})

export default {
	name: 'AddContact',
	props: ['data'],
	components: {
		CustomSelect,
		CustomMultiselect
	},
	data () {
		return {
			user: {
				firstname: null,
				lastname: null,
				phone: null,
				email: null,
				origin: null,
				centerOfInterests: [],
				type: 'Client',
				birthdate: null,
				address: {
					line: null,
					zip: null,
					city: null,
					country: null
				}
			},
			prospectTypes: ['Client', 'Prospect'],
			origins: ['Site web', 'Téléphone', 'Email', 'Salon', 'Réseau']
		}
	},
	mounted () {
		this.user.id = this.data.id
		this.user.firstname = this.data.firstname
		this.user.lastname = this.data.lastname
		this.user.phone = this.data.phone
		this.user.email = this.data.email
		this.user.type = (this.data.type === 'client_subscriber') ? 'Client' : 'Prospect'
		this.user.origin = this.data.source
		this.user.centerOfInterests = this.data.center_of_interest.slice()
		let bd = this.data.birthdate
		bd = bd.getDate() + '-' + ('00' + (bd.getMonth() + 1)).slice(-2) + '-' + bd.getFullYear()
		this.user.birthdate = bd.split('-').reverse().join('-')
		this.user.address = this.data.address
	},
	methods: {
		close () {
			this.$emit('close')
		},
		addContact () {
			this.$store.dispatch('editClient', this.user).then(() => {
				this.$notify({
					type: 'success',
					group: 'default',
					title: 'Votre contact a bien été édité',
					text: ''
				})
				this.$emit('close')
			}).catch(() => {
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue à l\'édition du contact',
					text: 'Veuillez vérifier que les informations que vous avez renseignées sont correctes'
				})
			})
		},
		setNewCenterOfInterests (values) {
			this.user.centerOfInterests = values
		}
	},
	computed: {
		...mapGetters({
			interests: 'tags'
		})
	}
}
</script>

<style lang="scss" scoped>

.head-modal {
	justify-content: space-between;

	.title {
		align-items: flex-start;
	}
}

.body-modal {
	overflow-y: auto;
}

.ctn-label {
	label {
		text-transform: uppercase;
	}
}

.form-elem-container {
	width: 100%;

	&.ctn-select.ctn-label {
		margin: 0;
		margin-bottom: 1rem;
	}

	label {
		color: #404040;
		font-size: 0.7rem;
		font-family: 'Lato Bold';
		opacity: 0.5;
	}
}

.form-elem-container.small {
	width: 150px;
	position: relative;

	.ctn-input.ctn-label {
		border-color: #cfcfcf;

		label {
			color: #404040;
			text-transform: uppercase;
			font-size: 0.6rem;
			font-family: 'Lato Bold';
			opacity: 0.7;
			position: absolute;
			top: -40%;
			width: 100%;
			left: 0;
		}
	}
}

</style>



// WEBPACK FOOTER //
// EditContact.vue?4dc68da4